import React from 'react'

export const StorageError = () => {
    return (
        <div className="error__container">
            <h1>
                Для подальшої роботи у системі увімкніть, будь-ласка, LocalStorage і SessionStorage
            </h1>
        </div>
    );
};

